/*
The filter UI should go like this:
====================================
Filter by Text:
contains [x] does not contain [ ]
+----------------------------------+
| Field text                       |
+----------------------------------+
====================================
Filter by Range between
+------------+     +---------------+
| Start      | and | End           |
+------------+     +---------------+
====================================
                 $$$$$$$$$$$$$$$$$$$
                 $$ Clear Filters $$
                 $$$$$$$$$$$$$$$$$$$
=====================================

 */
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import {Modal} from "@mui/material";
import RangeColumnFilter from "./RangeColumnFilter";
import TextColumnFilter from "./TextColumnFilter";


export const ColumnFilter = ({columnDef, hideModal, onChange, setHideModal, hidden}) => {
    return <Modal
        open={!hideModal}
        onClose={() => {
            setHideModal(true);
        }}
        className={"canold-table-column-filter-modal" + (hidden ? " hidden" : "")}
    >
        <div
            className={"canold-table-column-filter-container"}
        >
            <CloseIcon
                className={"canold-table-column-filter-close-icon"}
                role={"close-icon"}
                onClick={() => {
                    setHideModal(true);
                }}
            />
            <h2>Search for &quot;{columnDef.displayName}&quot; rows</h2>
            {columnDef.isNumber ? null : <TextColumnFilter colDef={columnDef} onChange={onChange}/>}
            {columnDef.isNumber ? <RangeColumnFilter colDef={columnDef} onChange={onChange}/> : null}
        </div>
    </Modal>;
};


export default ColumnFilter;